import { ResourceGroupEmployeesTable } from "@components/Tables/ResourceGroupEmployeesTable/ResourceGroupEmployeesTable";

import { Card } from "@design-system/Card/Card";

type Props = {
  title?: string;
  clientId: string;
  applicationId: string; // This is the client application ID
};

export const ApplicationUsersCard = ({
  title = "User list",
  clientId,
  applicationId,
}: Props) => {
  return (
    <Card grow>
      <Card.Header withBottomPadding>
        <Card.Header.Title>{title}</Card.Header.Title>
      </Card.Header>
      <Card.Body noPadding grow>
        <ResourceGroupEmployeesTable
          clientId={clientId}
          clientApplicationId={applicationId}
        />
      </Card.Body>
    </Card>
  );
};
